import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IProvince } from "../../utils/types/models";

export default createEntityReducer<IProvince>(Endpoint.Provinces, Endpoint.ProvincesList);
